module.exports = __webpack_public_path__ + "img/app.655310c3.webp";